import script from "./LinearRegressionChannel.vue?vue&type=script&lang=js"
export * from "./LinearRegressionChannel.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__